import React, { useState, createContext, useContext } from 'react';
type Language = 'en' | 'es';
interface TranslationContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: string) => string;
}
const translations = {
  en: {
    // Navbar
    'nav.aboutUs': 'About Us',
    'nav.funding': 'Funding',
    'nav.howItWorks': 'How it Works',
    'nav.requirements': 'Who Qualifies',
    'nav.testimonials': 'Testimonial',
    'nav.security': 'Security',
    'nav.faq': 'FAQ',
    'nav.contactUs': 'Contact Us',
    'nav.login': 'Login',
    'nav.applyNow': 'Apply Now',
    // Hero
    'hero.badge': 'Commercial Funding',
    'hero.title': 'Commercial Funding for Business Owners in the United States',
    'hero.titleHighlight': '',
    'hero.titleSuffix': '',
    'hero.subtitle': 'We offer financing options for all types of businesses. We evaluate the best alternatives available for you with a simple and personalized process.',
    'hero.cta': 'APPLY NOW',
    'hero.ctaSecondary': 'SCHEDULE CONSULTATION',
    'hero.microcopy1': 'No personal credit impact',
    'hero.microcopy2': 'No initiation fee',
    'hero.microcopy3': 'Approvals in 48 hrs',
    'hero.trustedBy': 'Trusted by 5,000+ Business Owners',
    'hero.trustpilot': 'Excellent on Trustpilot',
    'hero.approvalBadge1': '$150,000 Approved',
    'hero.approvalBadge2': '$200,000 Approved',
    'hero.approvalBadge3': '$75,000 Approved',
    // Benefits Ticker
    'ticker.fastApprovals': 'Fast Approvals',
    'ticker.noUpfront': 'No Upfront Fees',
    'ticker.softCredit': 'Soft Credit Pull',
    'ticker.flexible': 'Flexible Terms',
    'ticker.sameDay': 'Same-Day Funding',
    'ticker.approval': '99% Approval Rates',
    // Value Proposition
    'value.eyebrow': '¿WHY DO BUSINESS OWNERS CHOOSE BRIXEN FUNDING?',
    'value.title': 'The Easiest Way to Secure Capital.',
    'value.titleHighlight': '',
    'value.subtitle': 'At Brixen Funding, we simplify the complex world of business lending. Instead of applying lender by lender, our single application connects you to over 75+ private lenders and banks instantly. We force them to compete for your business, ensuring you get higher approval amounts, lower rates, and funding in hours — not weeks.',
    'value.feature1.title': 'Top Lenders',
    'value.feature1.desc': 'Access to 75+ private lenders & national banks.',
    'value.feature2.title': 'Tailored Funding',
    'value.feature2.desc': 'Offers customized specifically to your industry.',
    'value.feature3.title': 'Quick Approvals',
    'value.feature3.desc': 'Decisions in hours, funding same-day.',
    'value.feature4.title': 'No Collateral',
    'value.feature4.desc': 'Unsecured options available (No assets needed).',
    'value.cta': 'APPLY NOW',
    // Funding Solutions
    'solutions.eyebrow': 'WHY BUSINESS OWNERS CHOOSE BRIXEN FUNDING',
    'solutions.title': 'Funding Solutions for Every Stage of Your Business',
    'solutions.titleHighlight': '',
    'solutions.subtitle': '',
    'solutions.card1.title': 'Revenue Based Funding',
    'solutions.card1.desc': 'Flexible funding based on your monthly sales. Bad Credit Accepted. No collateral required.',
    'solutions.card2.title': 'Business Credit Cards',
    'solutions.card2.desc': 'Access up to $150k in Business Credit Cards with 0% APR for 12 months.',
    'solutions.card3.title': 'Business Lines of Credit',
    'solutions.card3.desc': 'Revolving capital on demand. Draw funds as needed and pay interest only on the amount you use.',
    'solutions.card4.title': 'Working Capital Loans',
    'solutions.card4.desc': 'Quick cash to cover payroll, inventory, or expansion. Funded in 48 hours.',
    'solutions.card5.title': 'Equipment Financing',
    'solutions.card5.desc': 'Acquire machinery, vehicles, or technology without draining your cash reserves.',
    'solutions.card6.title': 'Term Loans',
    'solutions.card6.desc': 'Traditional loans with longer repayment terms and higher limits.',
    'solutions.card7.title': 'SBA Programs',
    'solutions.card7.desc': 'Government-backed loans, offering the lowest market rates and terms up to 25 years.',
    'solutions.card8.title': 'Startup Capital',
    'solutions.card8.desc': 'Specialized funding programs to help launch your new business. (750+ Credit Score Required).',
    'solutions.cta': 'SCHEDULE CONSULTATION',
    // How It Works
    'howItWorks.eyebrow': '',
    'howItWorks.title': 'How Does It Work',
    'howItWorks.titleHighlight': '',
    'howItWorks.subtitle': '',
    'howItWorks.step1.title': 'Apply Online',
    'howItWorks.step1.desc': 'Complete the secure application form in less than 5 minutes.',
    'howItWorks.step2.title': 'We Compare Offers',
    'howItWorks.step2.desc': 'We send your application to our private lenders to get the best options for you.',
    'howItWorks.step3.title': 'Receive Your Funds',
    'howItWorks.step3.desc': 'Funds are deposited into your bank account via ACH within 24-48 hours.',
    'howItWorks.cta': 'APPLY NOW',
    // Requirements
    'requirements.eyebrow': 'WHO QUALIFIES',
    'requirements.title': 'Basic Requirements',
    'requirements.titleHighlight': '',
    'requirements.subtitle': "Don't meet every requirement? Apply anyway. We have special programs for unique situations.",
    'requirements.req1.title': '8+ Months',
    'requirements.req1.desc': 'In Business',
    'requirements.req2.title': '$20,000+',
    'requirements.req2.desc': 'Monthly Revenue',
    'requirements.req3.title': '500+',
    'requirements.req3.desc': 'FICO Score',
    'requirements.req4.title': 'LLC / Corp',
    'requirements.req4.desc': 'Business Entity',
    'requirements.req5.title': '3 Months',
    'requirements.req5.desc': 'Business Bank Statements',
    'requirements.cta': 'SCHEDULE CONSULTATION',
    // Testimonials
    'testimonials.eyebrow': 'TESTIMONIALS / RESULTS',
    'testimonials.title': 'Real Results from Real Business Owners',
    'testimonials.titleHighlight': '',
    'testimonials.subtitle': 'See why thousands of American entrepreneurs trust Brixen Funding.',
    'testimonials.trustTitle': 'Trusted by 5,000+ Loyal Clients',
    'testimonials.trustDesc': 'We pride ourselves on transparency and speed. Read why businesses across the country choose us over traditional banks.',
    // Trust & Security
    'trust.eyebrow': 'TRUST, COMPLIANCE & SECURITY',
    'trust.title': 'Basic Requirements',
    'trust.titleHighlight': '',
    'trust.subtitle': '',
    'trust.item1.title': 'Brokers, Not Lenders',
    'trust.item1.desc': 'We work for you, not the banks, to secure the best rates.',
    'trust.item2.title': 'No Upfront Fees',
    'trust.item2.desc': 'Zero cost to apply. We only get paid when you get funded.',
    'trust.item3.title': 'Verified Lenders',
    'trust.item3.desc': 'Access our trusted network of top-tier private lenders.',
    'trust.item4.title': 'Secure Application',
    'trust.item4.desc': 'Your data is protected by 256-bit bank-level encryption.',
    'trust.item5.title': 'Transparent Process',
    'trust.item5.desc': 'No hidden fees. Clear terms from start to finish.',
    'trust.cta': 'SCHEDULE CONSULTATION',
    // FAQ
    'faq.eyebrow': 'FIND QUICK ANSWERS TO COMMON QUESTIONS',
    'faq.title': 'Answers to Your Funding Questions',
    'faq.titleHighlight': '',
    // Contact
    'contact.eyebrow': 'CONTACT US',
    'contact.title': 'Speak With a Funding Specialist',
    'contact.titleHighlight': '',
    'contact.subtitle': 'Have questions about your funding options? Our US-based team is ready to analyze your business goals and match you with the right capital solution.',
    'contact.address': 'Company Address',
    'contact.phone': 'Talk To Us',
    'contact.hours': 'Office Days',
    'contact.hoursValue': 'Mon - Fri: 9:00 AM - 5:00 PM EST\nSat - Sun: Closed',
    'contact.email': 'Email Us',
    'contact.formTitle': 'Get a Free Consultation',
    'contact.firstName': 'First Name',
    'contact.lastName': 'Last Name',
    'contact.emailLabel': 'Email',
    'contact.phoneLabel': 'Phone',
    'contact.company': 'Company Name',
    'contact.interested': 'Interested in',
    'contact.selectOption': 'Select a funding option...',
    'contact.message': 'Additional Message',
    'contact.messagePlaceholder': 'Tell us about your funding needs...',
    'contact.submit': 'Request Call Back',
    'contact.successTitle': 'Request Received!',
    'contact.successMessage': 'Redirecting you to WhatsApp to complete your request...',
    // Footer
    'footer.description': 'Empowering businesses with fast, transparent, and flexible funding solutions.',
    'footer.quickLinks': 'Quick Links',
    'footer.contact': 'Contact',
    'footer.hoursTitle': 'Hours of Operation',
    'footer.hoursDay': 'Monday - Friday',
    'footer.hoursTime': '9:00 AM - 5:00 PM EST',
    'footer.hoursClosed': 'Closed on Weekends',
    'footer.disclaimer1': 'Brixen Funding LLC is a financial brokerage service, not a direct lender. All financing offers, approvals, and funding amounts are issued by third-party lenders in our network and are subject to lender requirements.',
    'footer.disclaimer2': 'This site is not affiliated with or endorsed by Facebook or Meta Platforms, Inc. "Facebook" and "Meta" are registered trademarks of Meta Platforms, Inc.',
    'footer.disclaimer3': 'Information shared on this website is for informational purposes only and does not constitute legal or financial advice. Results vary by individual business profile. By using this site or our services, you agree to our Terms & Conditions and Privacy Policy, and consent to receive communications (including SMS and calls) from Brixen Funding LLC under applicable laws.',
    'footer.copyright': '© 2026 Brixen Funding LLC. All Rights Reserved.',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms & Conditions'
  },
  es: {
    // Navbar
    'nav.aboutUs': 'Nosotros',
    'nav.funding': 'Financiamiento',
    'nav.howItWorks': 'Cómo Funciona',
    'nav.requirements': 'Requisitos',
    'nav.testimonials': 'Testimonios',
    'nav.security': 'Seguridad',
    'nav.faq': 'FAQ',
    'nav.contactUs': 'Contacto',
    'nav.login': 'Iniciar Sesión',
    'nav.applyNow': 'Aplicar Ahora',
    // Hero
    'hero.badge': 'Financiamiento Comercial',
    'hero.title': 'Financiamiento Comercial para Dueños de Negocio en Estados Unidos',
    'hero.titleHighlight': '',
    'hero.titleSuffix': '',
    'hero.subtitle': 'Ofrecemos opciones de financiamiento para todo tipo de negocio. Evaluamos las mejores alternativas disponibles para ti con un proceso simple y personalizado.',
    'hero.cta': 'APLICAR AHORA',
    'hero.ctaSecondary': 'AGENDAR CONSULTA',
    'hero.microcopy1': 'Sin afectar tu crédito personal',
    'hero.microcopy2': 'Sin fee de iniciación',
    'hero.microcopy3': 'Aprobaciones en 48 hrs',
    'hero.trustedBy': '+5,000 Clientes Financiados',
    'hero.trustpilot': '4.8 Rate on Trustpilot',
    'hero.approvalBadge1': '$150,000 Aprobado',
    'hero.approvalBadge2': '$200,000 Aprobado',
    'hero.approvalBadge3': '$75,000 Aprobado',
    // Benefits Ticker
    'ticker.fastApprovals': 'Aprobaciones Rápidas',
    'ticker.noUpfront': 'Sin Cargos Iniciales',
    'ticker.softCredit': 'Consulta de Crédito Suave',
    'ticker.flexible': 'Términos Flexibles',
    'ticker.sameDay': 'Fondos el Mismo Día',
    'ticker.approval': '99% Tasa de Aprobación',
    // Value Proposition
    'value.eyebrow': '¿Por Qué Dueños de Negocio Eligen Brixen Funding?',
    'value.title': 'La Forma Más Fácil de Asegurar Capital.',
    'value.titleHighlight': '',
    'value.subtitle': 'En Brixen Funding, simplificamos el complejo mundo de los préstamos comerciales. En lugar de aplicar prestamista por prestamista, nuestra única aplicación te conecta con más de 75 prestamistas privados y bancos al instante. Los obligamos a competir por tu negocio, asegurando que obtengas montos de aprobación más altos, tasas más bajas y financiamiento en horas, no en semanas.',
    'value.feature1.title': 'Mejores Prestamistas',
    'value.feature1.desc': 'Acceso a más de 75 prestamistas privados y bancos nacionales.',
    'value.feature2.title': 'Financiamiento a Medida',
    'value.feature2.desc': 'Ofertas personalizadas específicamente para tu industria.',
    'value.feature3.title': 'Aprobaciones Rápidas',
    'value.feature3.desc': 'Decisiones en horas, financiamiento el mismo día.',
    'value.feature4.title': 'Sin Garantía',
    'value.feature4.desc': 'Opciones sin garantía disponibles (No se necesitan activos).',
    'value.cta': 'APLICAR AHORA',
    // Funding Solutions
    'solutions.eyebrow': 'POR QUÉ LOS DUEÑOS DE NEGOCIOS ELIGEN BRIXEN FUNDING',
    'solutions.title': 'Soluciones de Financiamiento para Cada Etapa de tu Negocio',
    'solutions.titleHighlight': '',
    'solutions.subtitle': '',
    'solutions.card1.title': 'Financiamiento Basado en Ingresos',
    'solutions.card1.desc': 'Financiamiento flexible basado en tus ventas mensuales. Se acepta mal crédito. No se requiere garantía.',
    'solutions.card2.title': 'Tarjetas de Crédito Comerciales',
    'solutions.card2.desc': 'Accede hasta $150k en Tarjetas de Crédito Comerciales con 0% APR por 12 meses.',
    'solutions.card3.title': 'Líneas de Crédito Comerciales',
    'solutions.card3.desc': 'Capital rotativo a demanda. Retira fondos según los necesites y paga intereses solo por el monto que uses.',
    'solutions.card4.title': 'Préstamos de Capital de Trabajo',
    'solutions.card4.desc': 'Efectivo rápido para cubrir nómina, inventario o expansión. Financiado en 48 horas.',
    'solutions.card5.title': 'Financiamiento de Equipos',
    'solutions.card5.desc': 'Adquiere maquinaria, vehículos o tecnología sin agotar tus reservas de efectivo.',
    'solutions.card6.title': 'Préstamos a Plazo',
    'solutions.card6.desc': 'Préstamos tradicionales con plazos de pago más largos y límites más altos.',
    'solutions.card7.title': 'Programas SBA',
    'solutions.card7.desc': 'Préstamos respaldados por el gobierno, ofreciendo las tasas de mercado más bajas y plazos de hasta 25 años.',
    'solutions.card8.title': 'Capital Inicial',
    'solutions.card8.desc': 'Programas de financiamiento especializados para ayudar a lanzar tu nuevo negocio. (Se requiere un puntaje de crédito de 750+).',
    'solutions.cta': 'AGENDAR CONSULTA',
    // How It Works
    'howItWorks.eyebrow': '',
    'howItWorks.title': 'Cómo Funciona',
    'howItWorks.titleHighlight': '',
    'howItWorks.subtitle': '',
    'howItWorks.step1.title': 'Aplica en Línea',
    'howItWorks.step1.desc': 'Completa el formulario de aplicación segura en menos de 5 minutos.',
    'howItWorks.step2.title': 'Comparamos Ofertas',
    'howItWorks.step2.desc': 'Enviamos tu aplicación a nuestros lenders privados para obtener las mejores opciones para ti.',
    'howItWorks.step3.title': 'Recibes los Fondos',
    'howItWorks.step3.desc': 'Los fondos son depositados en tu cuenta bancaria a través de un ACH en un periodo de 24-48 hrs.',
    'howItWorks.cta': 'APLICAR AHORA',
    // Requirements
    'requirements.eyebrow': 'QUIÉN CALIFICA',
    'requirements.title': 'Requisitos Básicos',
    'requirements.titleHighlight': '',
    'requirements.subtitle': '¿No cumples con todos los requisitos? Aplica de todos modos. Tenemos programas especiales para situaciones únicas.',
    'requirements.req1.title': '8+ Meses',
    'requirements.req1.desc': 'En Operación',
    'requirements.req2.title': '$20,000+',
    'requirements.req2.desc': 'Ingresos Mensuales',
    'requirements.req3.title': '500+',
    'requirements.req3.desc': 'Puntaje FICO',
    'requirements.req4.title': 'LLC / Corp',
    'requirements.req4.desc': 'Entidad Legal',
    'requirements.req5.title': '3 Meses',
    'requirements.req5.desc': 'Estados de Cuenta Bancarios',
    'requirements.cta': 'AGENDAR CONSULTA',
    // Testimonials
    'testimonials.eyebrow': 'TESTIMONIOS / RESULTADOS',
    'testimonials.title': 'Resultados Reales de Dueños de Negocios Reales',
    'testimonials.titleHighlight': '',
    'testimonials.subtitle': 'Mira por qué miles de emprendedores estadounidenses confían en Brixen Funding.',
    'testimonials.trustTitle': 'Confiado por 5,000+ Clientes Leales',
    'testimonials.trustDesc': 'Nos enorgullecemos de la transparencia y la velocidad. Lee por qué las empresas de todo el país nos eligen sobre los bancos tradicionales.',
    // Trust & Security
    'trust.eyebrow': 'CONFIANZA, CUMPLIMIENTO Y SEGURIDAD',
    'trust.title': 'Requisitos Básicos',
    'trust.titleHighlight': '',
    'trust.subtitle': '',
    'trust.item1.title': 'Brokers, No Prestamistas',
    'trust.item1.desc': 'Trabajamos para ti, no para los bancos, para asegurar las mejores tasas.',
    'trust.item2.title': 'Sin Cargos Iniciales',
    'trust.item2.desc': 'Cero costo por aplicar. Solo nos pagan cuando obtienes financiamiento.',
    'trust.item3.title': 'Prestamistas Verificados',
    'trust.item3.desc': 'Accede a nuestra red confiable de prestamistas privados de primer nivel.',
    'trust.item4.title': 'Aplicación Segura',
    'trust.item4.desc': 'Tus datos están protegidos por encriptación de nivel bancario de 256 bits.',
    'trust.item5.title': 'Proceso Transparente',
    'trust.item5.desc': 'Sin tarifas ocultas. Términos claros de principio a fin.',
    'trust.cta': 'AGENDAR CONSULTA',
    // FAQ
    'faq.eyebrow': 'ENCUENTRA RESPUESTAS RÁPIDAS A PREGUNTAS COMUNES',
    'faq.title': 'Respuestas a Tus Preguntas de Financiamiento',
    'faq.titleHighlight': '',
    // Contact
    'contact.eyebrow': 'CONTÁCTANOS',
    'contact.title': 'Habla Con un Especialista en Financiamiento',
    'contact.titleHighlight': '',
    'contact.subtitle': '¿Tienes preguntas sobre tus opciones de financiamiento? Nuestro equipo con sede en EE. UU. está listo para analizar tus objetivos comerciales y conectarte con la solución de capital adecuada.',
    'contact.address': 'Dirección de la Empresa',
    'contact.phone': 'Háblanos',
    'contact.hours': 'Días de Oficina',
    'contact.hoursValue': 'Lun - Vie: 9:00 AM - 5:00 PM EST\nSáb - Dom: Cerrado',
    'contact.email': 'Envíanos un Correo',
    'contact.formTitle': 'Obtén una Consulta Gratuita',
    'contact.firstName': 'Nombre',
    'contact.lastName': 'Apellido',
    'contact.emailLabel': 'Correo Electrónico',
    'contact.phoneLabel': 'Teléfono',
    'contact.company': 'Nombre de la Empresa',
    'contact.interested': 'Interesado en',
    'contact.selectOption': 'Selecciona una opción de financiamiento...',
    'contact.message': 'Mensaje Adicional',
    'contact.messagePlaceholder': 'Cuéntanos sobre tus necesidades de financiamiento...',
    'contact.submit': 'Solicitar Llamada',
    'contact.successTitle': '¡Solicitud Recibida!',
    'contact.successMessage': 'Redirigiendo a WhatsApp para completar tu solicitud...',
    // Footer
    'footer.description': 'Empoderando a las empresas con soluciones de financiamiento rápidas, transparentes y flexibles.',
    'footer.quickLinks': 'Enlaces Rápidos',
    'footer.contact': 'Contacto',
    'footer.hoursTitle': 'Horario de Operación',
    'footer.hoursDay': 'Lunes - Viernes',
    'footer.hoursTime': '9:00 AM - 5:00 PM EST',
    'footer.hoursClosed': 'Cerrado los Fines de Semana',
    'footer.disclaimer1': 'Brixen Funding LLC es un servicio de corretaje financiero, no un prestamista directo. Todas las ofertas de financiamiento, aprobaciones y montos de financiamiento son emitidos por prestamistas externos en nuestra red y están sujetos a los requisitos del prestamista.',
    'footer.disclaimer2': 'Este sitio no está afiliado ni respaldado por Facebook o Meta Platforms, Inc. "Facebook" y "Meta" son marcas registradas de Meta Platforms, Inc.',
    'footer.disclaimer3': 'La información compartida en este sitio web es solo para fines informativos y no constituye asesoramiento legal o financiero. Los resultados varían según el perfil comercial individual. Al utilizar este sitio o nuestros servicios, aceptas nuestros Términos y Condiciones y Política de Privacidad, y consientes recibir comunicaciones (incluyendo SMS y llamadas) de Brixen Funding LLC bajo las leyes aplicables.',
    'footer.copyright': '© 2026 Brixen Funding LLC. Todos los Derechos Reservados.',
    'footer.privacy': 'Política de Privacidad',
    'footer.terms': 'Términos y Condiciones'
  }
};
const TranslationContext = createContext<TranslationContextType | undefined>(undefined);
export function TranslationProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<Language>('es');
  const t = (key: string): string => {
    return translations[lang][key] || key;
  };
  return <TranslationContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-563">
      {children}
    </TranslationContext.Provider>;
}
export function useTranslations() {
  const context = useContext(TranslationContext);
  if (context === undefined) {
    throw new Error('useTranslations must be used within a TranslationProvider');
  }
  return context;
}